module.exports = __webpack_public_path__ + "static/pinkcellular-95157751525ffab97051c2e256422609.png";